/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SearchQuery } from './SearchQuery';
import {
    SearchQueryFromJSON,
    SearchQueryFromJSONTyped,
    SearchQueryToJSON,
} from './SearchQuery';

/**
 * Representation of a Search State
 * @export
 * @interface SearchState
 */
export interface SearchState {
    /**
     * Url address of search state
     * @type {string}
     * @memberof SearchState
     */
    url?: string;
    /**
     * 
     * @type {SearchQuery}
     * @memberof SearchState
     */
    query?: SearchQuery;
}

/**
 * Check if a given object implements the SearchState interface.
 */
export function instanceOfSearchState(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SearchStateFromJSON(json: any): SearchState {
    return SearchStateFromJSONTyped(json, false);
}

export function SearchStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchState {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': !exists(json, 'url') ? undefined : json['url'],
        'query': !exists(json, 'query') ? undefined : SearchQueryFromJSON(json['query']),
    };
}

export function SearchStateToJSON(value?: SearchState | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'url': value.url,
        'query': SearchQueryToJSON(value.query),
    };
}

